import React, { useEffect, useState } from 'react'
import AdminHeader from "../Header/AdminHeader";
import AdminFooter from "../Footer/AdminFooter";
import AdminLeftMenu from "../Navbar/AdminLeftMenu";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPaperPlane, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { userloginDetails } from '../Utils/AdminAuth';
import { HOST_URL, NODE_HOST_URL_v1 } from '../Dashboard/api/Api';
import Axios from '../../axios/Axios';
import DeleteModal from '../Dashboard/campaign/Rcs/DeleteModal';

const Telemarketer = () => {
    const lStorage = userloginDetails();
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const adminType = lStorage.user.isAdmin;

    const customStyles = {
        control: (provided) => ({ ...provided, cursor: "pointer" }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        option: (style) => ({ ...style, fontSize: "12px" }),
    };

    const emptyForm = {
        telemarketerId: '',
        chainoperator: '',
        telemarketername: '',
        remarks: '',
    };

    const [selectedUser, setSelectedUser] = useState(null);
    const [searchList, setSearchList] = useState('');
    const [chainDataList, setChainDataList] = useState([]);
    const [editId, setEditId] = useState('');
    const [dataItem, setDataItem] = useState(emptyForm);
    const [deleteModal, setDeleteModal] = useState(false);
    const [chainid, setChainid] = useState('');
    const [isDeliveryPartner, setIsDeliveryPartner] = useState(false);
    const [error, setError] = useState({ status: false, bgColor: '', errorMessage: '' });
    const [statusConfirm, setStatusConfirm] = useState({ open: false, userid: null, currentStatus: null });

    useEffect(() => {
        MappingList();
    }, []);

    const loadUserOptions = async (inputValue) => {
        if (!inputValue || inputValue.trim().length < 1) return [];
        try {
            const { data } = await Axios.post(`${NODE_HOST_URL_v1}/admin/AdminTelemarketer`, {
                user_id: userId,
                token: userToken,
                method: "fetchUsers",
                username: inputValue,
            });
            if (data.success && data.data?.length > 0) {
                return data.data.map(u => ({ value: u.id, label: u.email }));
            }
            return [];
        } catch (err) {
            return [];
        }
    };


    const MappingList = async () => {
        try {
            const { data } = await Axios.post(`${NODE_HOST_URL_v1}/admin/AdminTelemarketer`, {
                user_id: userId,
                token: userToken,
                method: "fetchTelemarketer",
                filter: "all"
            });
            if (data.success) {
                setChainDataList([...data.data].sort((a, b) => new Date(b.created_date) - new Date(a.created_date)));
            } else {
                showError(data.message);
            }
        } catch (err) {
            showError(err.message);
        }
    };

    const showError = (msg, type = "danger") => {
        setError({ status: true, bgColor: `alert alert-${type}`, errorMessage: msg });
        setTimeout(() => setError({ status: false, bgColor: '', errorMessage: '' }), 3000);
    };

    const resetForm = () => {
        setSelectedUser(null);
        setDataItem(emptyForm);
        setEditId('');
        setIsDeliveryPartner(false);
    };

    const handleUserChange = (option) => {
        setSelectedUser(option);
        setError({ status: false, bgColor: '', errorMessage: '' });
    };

    const handleChange = (e) => {
        setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        setError({ status: false, bgColor: '', errorMessage: '' });
    };

    const isValid = () => {
        if (!selectedUser) return showError("Please select a user") || false;
        if (!dataItem.telemarketerId.trim()) return showError("Please enter Telemarketer ID") || false;
        if (!dataItem.chainoperator) return showError("Please select Chain Operator") || false;
        if (!dataItem.telemarketername.trim()) return showError("Please enter Telemarketer Name") || false;
        return true;
    };

    const SaveTelemarketer = async () => {
        if (!isValid()) return;
        try {
            const { data } = await Axios.post(`${NODE_HOST_URL_v1}/admin/AdminTelemarketer`, {
                user_id: userId,
                token: userToken,
                method: "createTelemarketer",
                retr_user_id: selectedUser.value,
                // username: selectedUser.label,
                telemarketerId: dataItem.telemarketerId,
                // delivery_function: dataItem.chainoperator,
                telemarketerName: dataItem.telemarketername,
                delivery_partner: dataItem.isDeliveryPartner,
                remark: dataItem.remarks,
                chainOperator: dataItem.chainoperator
            });
            if (data.success) {
                showError(data.message, "success");
                resetForm();
                MappingList();
            } else {
                showError(data.message);
            }
        } catch (err) {
            showError(err.message);
        }
    };

    const EditData = (record) => {
        let deliveryPatner = record.delivery_partner === 1 ? true : false
        setSelectedUser({ value: record.user_id, label: record.username });
        setDataItem({
            telemarketerId: record.telemarketer_id || '',
            chainoperator: record.operator || '',
            telemarketername: record.company || '',
            remarks: record.remarks || '',
        });
        setIsDeliveryPartner(deliveryPatner);
        setEditId(record.id);
    };

    const UpdateData = async () => {
        if (!isValid()) return;
        try {
            const { data } = await Axios.post(`${NODE_HOST_URL_v1}/admin/AdminTelemarketer`, {
                user_id: userId,
                token: userToken,
                method: "updateTelemarketer",
                id: editId,
                telemarketerId: dataItem.telemarketerId,
                delivery_partner: dataItem.isDeliveryPartner,
                telemarketerName: dataItem.telemarketername,
                remark: dataItem.remarks,
                chainOperator: dataItem.chainoperator
            });
            if (data.success) {
                showError(data.message, "success");
                resetForm();
                MappingList();
            } else {
                showError(data.message);
            }
        } catch (err) {
            showError(err.message);
        }
    };

    const Delete = (id) => {
        setDeleteModal(true);
        setChainid(id);
    };

    const ClosePopup = () => {
        setDeleteModal(false);
        setChainid('');
    };

    const DeleteMapping = async () => {
        try {
            const { data } = await Axios.post(`${NODE_HOST_URL_v1}/admin/AdminTelemarketer`, {
                user_id: userId,
                token: userToken,
                method: "deleteTelemarketer",
                id: chainid,
            });
            if (data.success) {
                showError(data.message, "success");
                MappingList();
                ClosePopup();
            } else {
                showError(data.message);
            }
        } catch (err) {
            showError(err.message);
        }
    };

    const handleStatus = async () => {
        const { userid, currentStatus } = statusConfirm;
        setStatusConfirm({ open: false, userid: null, currentStatus: null });
        try {
            const newStatus = currentStatus === 1 ? 0 : 1;
            const { data } = await Axios.post(`${NODE_HOST_URL_v1}/admin/AdminTelemarketer`, {
                user_id: userId,
                token: userToken,
                method: "updateChainStatus",
                id: userid,
                chain_status: newStatus,
            });
            if (data.success) {
                showError(data.message, "success");
                MappingList();
            } else {
                showError(data.message);
            }
        } catch (err) {
            showError(err.message);
        }
    };

    return (
        <div>
            <div className="wrapper">
                <AdminLeftMenu />
                <div className="main">
                    <AdminHeader />
                    <main className="content">

                        {/* ── CREATE / EDIT FORM ── */}
                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title">
                                    {/* <FontAwesomeIcon className="mr-2" icon={faPaperPlane} /> */}
                                    {editId ? "Edit Telemarketer" : "Create Telemarketer"}
                                </h5>
                                <hr />

                                {error.status && (
                                    <div className={error.bgColor} role="alert">
                                        <button type="button" className="close" onClick={() => setError({ status: false })} aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                        {error.errorMessage}
                                    </div>
                                )}

                                <div className="row">
                                    <div className="col-md-4">
                                        <label>Users <span style={{ color: "red" }}>*</span></label>
                                        <AsyncSelect
                                            onChange={handleUserChange}
                                            loadOptions={loadUserOptions}
                                            value={selectedUser}
                                            placeholder="Type name to search user..."
                                            styles={customStyles}
                                            isDisabled={!!editId}
                                            defaultOptions={false}
                                            cacheOptions
                                            noOptionsMessage={({ inputValue }) =>
                                                inputValue ? "No record match" : "Type to search"
                                            }
                                            loadingMessage={() => "Searching..."}
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label>Telemarketer ID <span style={{ color: "red" }}>*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="telemarketerId"
                                            value={dataItem.telemarketerId}
                                            onChange={handleChange}
                                            placeholder="Enter Telemarketer ID"
                                            disabled={!!editId}
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label>Chain Operator <span style={{ color: "red" }}>*</span></label>
                                        <select
                                            className="form-control"
                                            name="chainoperator"
                                            value={dataItem.chainoperator}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Chain Operator</option>
                                            <option value="Airtel">Airtel</option>
                                            <option value="Vilpower">Vilpower</option>
                                            <option value="Jio">Jio</option>
                                            <option value="SmartPing">SmartPing</option>
                                            <option value="BSNL">BSNL</option>
                                            <option value="MTNL">MTNL</option>
                                            <option value="Tata">Tata</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="row mt-3">
                                    <div className="col-md-6">
                                        <label>Telemarketer Name <span style={{ color: "red" }}>*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="telemarketername"
                                            value={dataItem.telemarketername}
                                            onChange={handleChange}
                                            placeholder="Telemarketer Name for Identification"
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <label>Remarks</label>
                                        <textarea
                                            className="form-control"
                                            name="remarks"
                                            value={dataItem.remarks}
                                            onChange={handleChange}
                                            placeholder="Remarks for DLT-user / email (optional)"
                                        />
                                    </div>
                                </div>

                                <div className="row mt-2">
                                    <div className="col-md-12 d-flex justify-content-between align-items-center">
                                        <div className="d-flex align-items-center" style={{ gap: "6px" }}>
                                            <input
                                                type="checkbox"
                                                id="deliveryPartner"
                                                checked={isDeliveryPartner}
                                                onChange={(e) => setIsDeliveryPartner(e.target.checked)}
                                                style={{ cursor: "pointer", width: "16px", height: "16px" }}
                                            />
                                            <label htmlFor="deliveryPartner" className="mb-0" style={{ cursor: "pointer", fontWeight: 500 }}>
                                                Delivery Partner
                                            </label>
                                        </div>
                                        <div style={{ gap: "8px" }} className="d-flex">
                                            {editId && (
                                                <button type="button" onClick={resetForm} className="btn btn-secondary">
                                                    Cancel
                                                </button>
                                            )}
                                            <button type="button" onClick={editId ? UpdateData : SaveTelemarketer} className="btn btn-info">
                                                {editId ? "Update TM ID" : "Save TM ID"}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* ── LIST TABLE ── */}
                        <div className="card">
                            <div className="card-body">
                                <div className="row mb-2">
                                    <div className="col-md-8">
                                        <h5 className="card-title">
                                            {/* <FontAwesomeIcon className="mr-2" icon={faPaperPlane} /> */}
                                            Telemarketer List
                                        </h5>
                                    </div>
                                    <div className="col-md-4">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={searchList}
                                            onChange={(e) => setSearchList(e.target.value)}
                                            placeholder="Search..."
                                        />
                                    </div>
                                </div>
                                <hr />

                                <div className="table-responsive">
                                    <table className="table table-striped table-bordered">
                                        <thead className="table-dark">
                                            <tr>
                                                <th>Username</th>
                                                <th>Telemarketer ID</th>
                                                <th>Telemarketer Name/Company</th>
                                                <th>Remarks</th>
                                                <th>Operator</th>
                                                <th>Delivery Patner</th>
                                                <th>Chain Status</th>
                                                <th>Submitted On</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {chainDataList
                                                .filter(x => searchList === '' || x.username?.toLowerCase().includes(searchList.toLowerCase()))
                                                .map((user, i) => (
                                                    <tr key={i}>
                                                        <td>{user.username}</td>
                                                        <td>{user.telemarketer_id}</td>
                                                        <td>{user.company}</td>
                                                        <td>{user.remarks}</td>
                                                        <td>{user.operator}</td>
                                                        <td>{user.delivery_partner}</td>
                                                        <td>{user.chain_status === 1 ? 'YES' : 'NO'}</td>
                                                        <td>{user.created_date}</td>
                                                        <td>
                                                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                                <div
                                                                    title={user.chain_status === 1 ? "Active — click to deactivate" : "Inactive — click to activate"}
                                                                    style={{ width: 10, height: 10, borderRadius: "50%", backgroundColor: user.chain_status === 1 ? "#187C19" : "#ff0000", cursor: "pointer", flexShrink: 0 }}
                                                                    onClick={() => setStatusConfirm({ open: true, userid: user.id, currentStatus: user.chain_status })}
                                                                />
                                                                <FontAwesomeIcon
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={() => EditData(user)}
                                                                    icon={faEdit}
                                                                />
                                                                <FontAwesomeIcon
                                                                    style={{ cursor: "pointer", color: "red" }}
                                                                    onClick={() => Delete(user.id)}
                                                                    icon={faTrashAlt}
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        {statusConfirm.open && (
                            <div
                                style={{
                                    position: "fixed", top: 0, left: 0,
                                    width: "100%", height: "100%",
                                    backgroundColor: "rgba(0,0,0,0.5)",
                                    zIndex: 2000, display: "flex",
                                    alignItems: "center", justifyContent: "center",
                                }}
                            >
                                <div style={{
                                    background: "#fff", borderRadius: 10,
                                    padding: "28px 28px 22px", width: 360,
                                    boxShadow: "0 20px 50px rgba(0,0,0,0.2)", textAlign: "center",
                                }}>
                                    <div style={{
                                        width: 44, height: 44, borderRadius: "50%",
                                        backgroundColor: statusConfirm.currentStatus === 1 ? "#fee2e2" : "#dcfce7",
                                        display: "flex", alignItems: "center", justifyContent: "center",
                                        margin: "0 auto 14px",
                                    }}>
                                        <div style={{
                                            width: 14, height: 14, borderRadius: "50%",
                                            backgroundColor: statusConfirm.currentStatus === 1 ? "#ef4444" : "#22c55e",
                                        }} />
                                    </div>
                                    <h6 style={{ fontWeight: 600, fontSize: 15, marginBottom: 8 }}>
                                        Confirm Status Change
                                    </h6>
                                    <p style={{ fontSize: 13, color: "#6B7280", marginBottom: 20 }}>
                                        Are you sure you want to change the chain status from&nbsp;
                                        <strong>{statusConfirm.currentStatus === 1 ? "Active" : "Inactive"}</strong>
                                        &nbsp;to&nbsp;
                                        <strong>{statusConfirm.currentStatus === 1 ? "Inactive" : "Active"}</strong>?
                                    </p>
                                    <div className="d-flex justify-content-center" style={{ gap: 10 }}>
                                        <button
                                            className="btn btn-secondary btn-sm"
                                            onClick={() => setStatusConfirm({ open: false, userid: null, currentStatus: null })}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-primary btn-sm"
                                            onClick={handleStatus}
                                        >
                                            OK, Change Status
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        <DeleteModal show={deleteModal} onClose={ClosePopup} onDelete={DeleteMapping} />
                    </main>
                    <AdminFooter />
                </div>
            </div>
        </div>
    );
};

export default Telemarketer;
